// 注册vue全局过滤器
import Vue from 'vue'

// 筛选日期
Vue.filter('formDate', (value, format) => {
    if (value) {
      const date = new Date(value);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      if (format === 'YYYY-MM-DD') {
        return `${year}-${month}-${day}`;
      } else if (format === 'HH:mm:ss') {
        return `${hours}:${minutes}:${seconds}`;
      }else if(format === '年月日'){
        return `${year}年${month}月${day}日`;
      } 
      else {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }

    return '';
})